import {ISolicitacao, ISolicitacaoFiltroDto} from "@models/solicitacoes/solicitacoes.ts";
import {Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import React, {memo, useEffect, useState} from "react";
import {_SolicitacoesEndpoints} from "@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {SolicitacaoInfoRow,} from "@components/solicitacoes/solicitacao/SolicitacaoInfo.tsx";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {AddOutlined} from "@mui/icons-material";
import {CreateSolicitacaoPage} from "@components/solicitacoes/pages/CreateSolicitacaoPage.tsx";
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {SolicitacaoFiltrosPage} from "@components/solicitacoes/pages/solicitacoes/SolicitacaoFiltrosPage.tsx";
import {SearchTextField} from "@components/shared/textField/SearchTextField.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import usePagination from "@components/shared/hooks/usePagination.tsx";
import lodash from "lodash";

export interface SolicitacoesPageProps extends DefaultPageProps<ISolicitacaoFiltroDto> {
	recurso?: IRecurso,
	filtros?: ISolicitacaoFiltroDto
	slotProps?: {
		solicitacaoInformacao?: {
			EndComponent?: (v: ISolicitacao) => React.ReactNode
		}
	}
}

export const SolicitacoesPage: React.FC<SolicitacoesPageProps> = (props) => {
	const {addPopUp, closePopUp} = useAlert();
	const {Get} = useApi()

	const [solicitacoes, setSolicitacoes] = useState<ISolicitacao[]>([]);
	const [pagination, setPagination] = usePagination({
		...props.pageProps,
		triggers: [
			{
				eventName: 'process',
				promise: (p) => {
					return Get(_SolicitacoesEndpoints.GetSolicitacoes({
						finalizado: 'false',
						deveIncluir: ['UsuarioCriador'],
						layers: ['ValorEfetivado', 'ValorPendente', 'ItensPendentes', 'ItensFinalizados'],
						...filtros,
					}, p.pagination)).then(x => {
						if (x.status == 'Success') {
							setSolicitacoes(x.items);
						}
						return x
					})
				}
			}
		]
	});
	const [filtros, setFiltros] = useState<ISolicitacaoFiltroDto>({...props.filtersProps?.filters, ...props.filtros});

	useEffect(() => {
		if (props.filtersProps?.filters != null || props.filtros != null) {
			const newfiltros = {...filtros, ...props.filtersProps?.filters, ...props.filtros};

			if (!lodash.isEqual(newfiltros, filtros)) {
				setFiltros({...filtros, ...props.filtersProps?.filters, ...props.filtros});
			}
		}

	}, [props.filtros, props.filtersProps?.filters]);

	useEffect(() => {
		setPagination(({...pagination, page: 1, ignoreCache: true}));
	}, [filtros]);


	const CreatePage = memo(() => {
		return <CreateSolicitacaoPage recurso={props.recurso}
		                              onCreate={() => {
			                              setPagination({
				                              ...pagination,
				                              page: 1,
				                              ignoreCache: true,
			                              });
			                              closePopUp()
		                              }}
		                              hideHeader={true}/>
	})

	return (
		<DefaultContainer titulo={props.hideHeader ? '' : 'Solicitações'}
		                  component={Paper}
		                  UpperComponent={<Grid size={12}>
			                  <Grid container justifyContent={'space-between'} spacing={1}>
				                  <Grid size={{xs: 12, sm: 6}} container>
					                  <SearchTextField value={filtros.nome ?? ''}
					                                   onChange={(e) => {
						                                   setFiltros({...filtros, nome: e.target.value});
					                                   }}
					                                   pageProps={{pagination}}
					                                   label={'Pesquisa de solicitação'}
					                                   openFilters={() => {
						                                   addPopUp({
							                                   size: 'xl',
							                                   title: 'Filtros de solicitações',
							                                   content: <SolicitacaoFiltrosPage filters={filtros}
							                                                                    setFilters={(v) => {
								                                                                    console.log(v)
								                                                                    setFiltros(v);
								                                                                    closePopUp()
							                                                                    }}/>,
						                                   });
					                                   }} onSearch={() => {
						                  // setPagination({...pagination, page: 1, ignoreCache: true});
					                  }}/>
				                  </Grid>
				                  <Grid size={{xs: 12, sm: 6}} container>
					                  <PermissionableButton permission={['CriarSolicitacaoMembro']}
					                                        label={'Criar nova solicitação'}
					                                        showEvenWithoutAccess
					                                        icon={<AddOutlined/>}
					                                        fullHeight
					                                        onClick={() => {
						                                        addPopUp({
							                                        size: 'xl',
							                                        title: 'Nova solicitação',
							                                        content: <CreatePage/>,
						                                        })
					                                        }}
					                  />
				                  </Grid>
			                  </Grid>
		                  </Grid>}
		                  permissaoNecessaria={['VisualizarSolicitacoesMembro']}
		                  pageProps={{pagination, setPagination}}>
			<Grid size={12}>
				<Grid container>
					<Grid size={12}>
						<TableContainer>
							<Table size={'small'} stickyHeader>
								<TableHead>
									<TableRow>
										<TableCell>Id</TableCell>
										<TableCell>Solicitação</TableCell>
										<TableCell>Solicitante</TableCell>
										<TableCell align={'right'}>Data</TableCell>
										<TableCell align={'right'}>Valor / Pendente</TableCell>
										<TableCell>Itens / pendentes</TableCell>
										<TableCell align={'right'}>Mais</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{solicitacoes.map((x) => (
										<SolicitacaoInfoRow value={x}
										                    key={x.id}
										                    EndComponent={props.slotProps?.solicitacaoInformacao?.EndComponent}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>

					</Grid>
				</Grid>
			</Grid>
		</DefaultContainer>
	);
};

